<div class="editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="editor-field">
        <div class="editor-field-body">
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent()">
              </textarea>
            </mat-form-field>
          </div>
          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
            [config]="config"  [staticdata]="staticdata"
            [textContentClass]="class['export-bill--content__text']"
            [textWrapperClass]="class['export-bill--content__text']">
          </app-text-format-config>
          <!-- Gradient -->
          <div class="config-font">
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <p class="m-0" style="line-height:1.5">{{'do_mau_gradient' | translate}} <span style="font-size:13px">({{'da_sac' | translate}})</span></p>
              <nz-switch [(ngModel)]="config['background-image'].gradient_check"
                (ngModelChange)="handleSetGradientText()">
              </nz-switch>
            </div>
            <div class="container-gradient" *ngIf="config['background-image'].gradient_check">
              <div class="list-gradient">
                <button class="btn-gradient"
                  *ngFor="let bgGradient of config['background-image']['gradient_arr_gradient']; let i = index"
                  (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                  [disabled]="!config['background-image'].gradient_check">
                  <i class="delete-icon bi bi-x-circle"></i>
                </button>
              </div>
              <p class="title-head">{{ 'them_mau' | translate }}</p>
              <div class="container_add-gradient">
                <button class="btn-add-gradient" nzTooltipTitle="{{ 'them_mau' | translate }}" nz-tooltip
                  [disabled]="!config['background-image'].gradient_check" (click)="openbgGradient()"
                  (blur)="addGradient()">
                  <input nz-input type="color" class="picking-gradient" id="input-gradient-backlink"
                    [(ngModel)]="config['background-image']['gradient_background_color']">
                  <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                </button>
                <div class="slide_container-gradient">
                  <input type="range" min="1" max="100"
                    [value]="config['background-image']['gradient_opacity']" class="slider-gradient"
                    (input)="getValueRangeBackgroundGradient($event)"
                    [disabled]="!config['background-image'].gradient_check"
                    [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                </div>
                <div class="value-range">{{config['background-image']['gradient_opacity']}}%</div>
              </div>
              <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
              <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
                [nzTooltipTitle]="type.name" (click)="chooseOption(type, $event)"
                [disabled]="!config['background-image'].gradient_check"
                [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                [ngClass]="{ 'active': config['background-image']['gradient_direction'] === type.direction}">
              </button>
            </div>
          </div>
          <div class="field-row">
            <div class="config-font" style="margin-top:20px">
              <!-- Khoảng cách chữ -->
              <div class="font-text-letterspacing">
                <div class="config-name" style="gap:5px">
                  <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                    [ngModel]="class['export-bill--content__text']['letter-spacing'] | vhnumber"
                    (nzBlur)="updateClass()"
                    (ngModelChange)="class['export-bill--content__text']['letter-spacing'] = $event +'px'">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['export-bill--content__text']['letter-spacing'] | vhnumber"
                      (nzOnAfterChange)="updateClass();"
                      (ngModelChange)="class['export-bill--content__text']['letter-spacing'] = $event +'px'">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình cho text-->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <div class="editor-field">
          <div class="editor-field-body">
            <div class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label>{{'noi_dung' | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                  (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                  (blur)="updateStaticData()">
                </textarea>
              </mat-form-field>
            </div>
            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config"  [staticdata]="staticdata"
              [textContentClass]="class['export-bill--content__text']"
              [textWrapperClass]="class['export-bill--content__text']">
            </app-text-format-config>
            <!-- Gradient -->
            <div class="config-font">
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <p class="m-0" style="line-height:1.5">{{'do_mau_gradient' | translate}} <span style="font-size:13px">({{'da_sac' | translate}})</span></p>
                <nz-switch [(ngModel)]="config['background-image'].gradient_check"
                  (ngModelChange)="handleSetGradientText()">
                </nz-switch>
              </div>
              <div class="container-gradient" *ngIf="config['background-image'].gradient_check">
                <div class="list-gradient">
                  <button class="btn-gradient"
                    *ngFor="let bgGradient of config['background-image']['gradient_arr_gradient']; let i = index"
                    (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                    [disabled]="!config['background-image'].gradient_check">
                    <i class="delete-icon bi bi-x-circle"></i>
                  </button>
                </div>
                <p class="title-head">{{ 'them_mau' | translate }}</p>
                <div class="container_add-gradient">
                  <button class="btn-add-gradient" nzTooltipTitle="{{ 'them_mau' | translate }}" nz-tooltip
                    [disabled]="!config['background-image'].gradient_check" (click)="openbgGradient()"
                    (blur)="addGradient()">
                    <input nz-input type="color" class="picking-gradient" id="input-gradient-backlink"
                      [(ngModel)]="config['background-image']['gradient_background_color']">
                    <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                  </button>
                  <div class="slide_container-gradient">
                    <input type="range" min="1" max="100"
                      [value]="config['background-image']['gradient_opacity']" class="slider-gradient"
                      (input)="getValueRangeBackgroundGradient($event)"
                      [disabled]="!config['background-image'].gradient_check"
                      [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                  </div>
                  <div class="value-range">{{config['background-image']['gradient_opacity']}}%</div>
                </div>
                <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
                <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
                  [nzTooltipTitle]="type.name" (click)="chooseOption(type, $event)"
                  [disabled]="!config['background-image'].gradient_check"
                  [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                  [ngClass]="{ 'active': config['background-image']['gradient_direction'] === type.direction}">
                </button>
              </div>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div class="font-text-letterspacing">
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['export-bill--content__text']['letter-spacing'] | vhnumber"
                      (nzBlur)="updateClass()"
                      (ngModelChange)="class['export-bill--content__text']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['export-bill--content__text']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['export-bill--content__text']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- màu sắc và kích thước  -->
      <li nz-submenu [nzTitle]="'cau_hinh_o_chon' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <ul>
          <li>
            <div class="d-flex my-2 justify-content-between">
              <p class="w-50">{{'mau_nen_khi_chon' | translate}}</p>
              <input class="input-color w-50" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['checkbox__selected']['background-color']"
                [style.background]="class['checkbox__selected']['background-color']"
                (colorPickerClose)="updateClass()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
            </div>
          </li>
          <li>
            <div class="d-flex my-2 justify-content-between">
              <p class="w-50">{{'mau_nen_khi_chua_chon'}}</p>
              <input class="input-color w-50" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['checkbox__unselected']['background-color']"
                [style.background]="class['checkbox__unselected']['background-color']"
                (colorPickerClose)="updateClass()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
            </div>
          </li>

        </ul>
      </li>
      <li nz-submenu [nzTitle]="'kich_thuoc_checkbox' | translate" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <div class="field-row">
            <div class="config-name mt-2" style="gap:10px">
              <p class="m-0" style="line-height:1.5">{{'chieu_rong' | translate}}: </p>
              <nz-input-number [nzMin]="1" [nzStep]="1" [ngStyle]="{ width: '40%' }"
                [(ngModel)]="config['checkbox']['width']" (nzBlur)="changeSizeCheckbox('width', config['checkbox']['width'])">
              </nz-input-number>
            </div>
          </div>
          <div class="field-row">
            <div class="config-name mt-2" style="gap:10px">
              <p class="m-0" style="line-height:1.5">{{'chieu_cao' | translate}}: </p>
              <nz-input-number [nzMin]="1" [nzStep]="1" [ngStyle]="{ width: '40%' }"
                [(ngModel)]="config['checkbox']['height']" (nzBlur)="changeSizeCheckbox('height', config['checkbox']['height'])">
              </nz-input-number>
            </div>
          </div>
        </div>
      </li>
      <li nz-submenu [nzTitle]="'vi_tri_danh_dau' | translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="shadow-direction">
          <div class="dir-x">
            <div class="row-x">
              <span>{{'vi_tri' | translate}} X</span>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [ngModel]="staticdata['check_mark_positionX']" (nzOnAfterChange)=" updateObject()"
                (ngModelChange)="onChangePositionCheckmark($event, 'horizontal')"></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngModel]="staticdata['check_mark_positionX']"
                  (ngModelChange)="onChangePositionCheckmark($event, 'horizontal')"
                  (nzOnAfterChange)="updateObject()"></nz-slider>
              </nz-col>
            </nz-row>
          </div>
          <div class="dir-y">
            <div class="row-x">
              <span>{{'vi_tri' | translate}} Y</span>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [ngModel]="staticdata['check_mark_positionY']"
                (ngModelChange)="onChangePositionCheckmark($event, 'vertical')"
                (nzOnAfterChange)="updateClass()"></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngModel]="staticdata['check_mark_positionY']"
                  (ngModelChange)="onChangePositionCheckmark($event, 'vertical')"
                  (nzOnAfterChange)="updateClass()"></nz-slider>
              </nz-col>
            </nz-row>
          </div>
        </div>
      </li>
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="d-flex justify-content-between mx-1 p-2">
          <mat-icon>{{ staticdata.icon_name }}</mat-icon>
          <button nz-button nzType="default" (click)="openDialogChooseIcon()" style="border-radius: 5px">
            Thay đổi
          </button>
        </div>
        <ul>
          <li>
            <div class="d-flex my-2 justify-content-between">
              <p class="w-50">{{'mau_icon' | translate}}</p>
              <input class="input-color w-50" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['checkbox__selected--icon']['color']"
                [style.background]="class['checkbox__selected--icon']['color']" (colorPickerClose)="updateClass()"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
            </div>
          </li>
          <li>
            <div class="dir-x">
              <div class="container-row">
                <span>{{'kich_thuoc' | translate}}</span>
                <nz-input-number [nzMin]="0" [nzMax]="30" [nzStep]="1"
                  [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                  [ngModel]="class['checkbox__selected--icon']['font-size'] | vhnumber"
                  (ngModelChange)="class['checkbox__selected--icon']['font-size'] = $event + 'px'"
                  (nzBlur)="updateClass()"></nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="30" [nzStep]="1"
                    [ngModel]="class['checkbox__selected--icon']['font-size'] | vhnumber"
                    (ngModelChange)="class['checkbox__selected--icon']['font-size'] = $event + 'px'"
                    (nzOnAfterChange)="updateClass()"></nz-slider>
                </nz-col>
              </nz-row>
            </div>
          </li>
          <li>
            <div class="dir-x">
              <div class="container-row">
                <span>{{'do_dam' | translate}}</span>
                <nz-input-number [nzMin]="0" [nzMax]="1000" [nzStep]="100"
                  [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                  [ngModel]="class['checkbox__selected--icon']['font-weight'] | vhnumber"
                  (ngModelChange)="class['checkbox__selected--icon']['font-weight'] = $event"
                  (nzBlur)="updateClass()"></nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="1000" [nzStep]="100"
                    [ngModel]="class['checkbox__selected--icon']['font-weight'] | vhnumber"
                    (ngModelChange)="class['checkbox__selected--icon']['font-weight'] = $event"
                    (nzOnAfterChange)="updateClass()"></nz-slider>
                </nz-col>
              </nz-row>
            </div>
          </li>
        </ul>
      </li>
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="item-shadow">
          <p class="m-0 title">{{'ap_dung' | translate}}g</p>
          <nz-switch [(ngModel)]="config['box-shadow']['shadow_check']"
            (ngModelChange)="onChangeShadow(); updateObject()"></nz-switch>
        </div>
        <div class="shadow-direction">
          <div class="dir-x">
            <div class="row-x">
              <span>{{'truc_x' | translate}}</span>
              <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [(ngModel)]="config['box-shadow']['offset_x']" (ngModelChange)="onChangeShadow()"
                (nzOnAfterChange)=" updateObject()"
                [disabled]="!config['box-shadow']['shadow_check']"></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['offset_x']"
                  (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()"
                  [nzDisabled]="!config['box-shadow']['shadow_check']"></nz-slider>
              </nz-col>
            </nz-row>
          </div>
          <div class="dir-y">
            <div class="row-x">
              <span>{{'truc_y' | translate}}</span>
              <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [(ngModel)]="config['box-shadow']['offset_y']" (ngModelChange)="onChangeShadow()"
                (nzOnAfterChange)="updateObject()"
                [disabled]="!config['box-shadow']['shadow_check']"></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['offset_y']"
                  (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()"
                  [nzDisabled]="!config['box-shadow']['shadow_check']"></nz-slider>
              </nz-col>
            </nz-row>
          </div>
          <div class="dir-b">
            <div class="row-b">
              <span style="line-height: 1.5">{{'lam_mo' | translate}}</span>
              <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ width: '40%' }"
                [(ngModel)]="config['box-shadow']['blur_radius']" (ngModelChange)="onChangeShadow()"
                (nzOnAfterChange)="updateObject()"
                [disabled]="!config['box-shadow']['shadow_check']"></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['blur_radius']"
                  (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()"
                  [nzDisabled]="!config['box-shadow']['shadow_check']"></nz-slider>
              </nz-col>
            </nz-row>
          </div>
        </div>
        <div class="item-shadow">
          <p class="m-0 title w-50">{{'mau_bong' | translate}}</p>
          <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="config['box-shadow']['shadow_color']"
            [style.background]="config['box-shadow']['shadow_color']" (colorPickerChange)="onChangeShadow()"
            (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
            [disabled]="!config['box-shadow']['shadow_check']" />
        </div>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <div class="item-border">
          <p class="m-0 title-border">{{'kieu_vien' | translate}}</p>
          <div class="field-widget">
            <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menuBorder" nzPopoverTrigger="click">
              <mat-icon>border_style</mat-icon>
            </button>
          </div>
          <!-- Menu các kiểu viền khác -->
          <nz-dropdown-menu #menuBorder="nzDropdownMenu">
            <ul nz-menu>
              <!-- Kiểu viền solid -->
              <li nz-menu-item>
                <button (click)="class['checkbox__selected']['border-style']  = 'solid'; updateClass()" nz-tooltip
                  nzTooltipTitle="Solid" nzTooltipPlacement="left" class="widget-button"
                  [ngClass]="{'active': class['checkbox__selected']['border-style']  == 'solid'}">
                  <div class="icon-field">
                    <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                        fill="#000000" />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền double -->
              <li nz-menu-item>
                <button (click)="class['checkbox__selected']['border-style']  = 'double'; updateClass()" nz-tooltip
                  nzTooltipTitle="Double" nzTooltipPlacement="left" class="widget-button"
                  [ngClass]="{'active': class['checkbox__selected']['border-style']  == 'double'}">
                  <div class="icon-field">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-outline-style" viewBox="0 0 16 16">
                      <path
                        d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền dashed -->
              <li nz-menu-item>
                <button (click)="class['checkbox__selected']['border-style']  = 'dashed'; updateClass()" nz-tooltip
                  nzTooltipTitle="Dashed" nzTooltipPlacement="left" class="widget-button"
                  [ngClass]="{'active': class['checkbox__selected']['border-style']  == 'dashed'}">
                  <div class="icon-field">
                    <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                        fill="#000000" />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền dotted -->
              <li nz-menu-item>
                <button (click)="class['checkbox__selected']['border-style']  = 'dotted'; updateClass()" nz-tooltip
                  nzTooltipTitle="Dotted" nzTooltipPlacement="left" class="widget-button"
                  [ngClass]="{'active': class['checkbox__selected']['border-style']  == 'dotted'}">
                  <div class="icon-field">
                    <i class="bi bi-three-dots"></i>
                  </div>
                </button>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
        <ul class="p-0">
          <li class="item-border-size">
            <!-- Điều chỉnh kích thước viền trên-->
            <div class="row-border">
              <p class="m-0 title-border" style="line-height: 1.5;">{{'kich_thuoc_vien_tren' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="1" style="min-width:40%"
                [ngModel]="class['checkbox__selected']['border-top-width'] | vhnumber"
                (nzBlur)="updateClassAndWidthHeight()"
                (ngModelChange)="class['checkbox__selected']['border-top-width'] = $event +'px'"></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="10" [nzStep]="1"
                  [ngModel]="class['checkbox__selected']['border-top-width'] | vhnumber"
                  (nzOnAfterChange)="updateClassAndWidthHeight()"
                  (ngModelChange)="class['checkbox__selected']['border-top-width'] = $event +'px'"></nz-slider>
              </nz-col>
            </nz-row>
            <!-- Điều chỉnh kích thước viền phải -->
            <div class="row-border">
              <p class="m-0 title-border" style="line-height: 1.5;">{{'kich_thuoc_vien_phai' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="1" style="min-width:40%"
                [ngModel]="class['checkbox__selected']['border-right-width'] | vhnumber"
                (nzBlur)="updateClassAndWidthHeight()"
                (ngModelChange)="class['checkbox__selected']['border-right-width'] = $event +'px'"></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="10" [nzStep]="1"
                  [ngModel]="class['checkbox__selected']['border-right-width'] | vhnumber"
                  (nzOnAfterChange)="updateClassAndWidthHeight()"
                  (ngModelChange)="class['checkbox__selected']['border-right-width'] = $event +'px'"></nz-slider>
              </nz-col>
            </nz-row>
            <!-- Điều chỉnh kích thước viền trái -->
            <div class="row-border">
              <p class="m-0 title-border" style="line-height: 1.5;">{{'kich_thuoc_vien_trai' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="1" style="min-width:40%"
                [ngModel]="class['checkbox__selected']['border-left-width'] | vhnumber"
                (nzBlur)="updateClassAndWidthHeight()"
                (ngModelChange)="class['checkbox__selected']['border-left-width'] = $event +'px'"></nz-input-number>
            </div>
            <div>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="10" [nzStep]="1"
                  [ngModel]="class['checkbox__selected']['border-left-width'] | vhnumber"
                  (nzOnAfterChange)="updateClassAndWidthHeight()"
                  (ngModelChange)="class['checkbox__selected']['border-left-width'] = $event +'px'"></nz-slider>
              </nz-col>
              <!-- Điều chỉnh kích thước viền trên dưới phải -->
              <div class="row-border">
                <p class="m-0 title-border" style="line-height: 1.5;">{{'kich_thuoc_vien_duoi' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="1" style="min-width:40%"
                  [ngModel]="class['checkbox__selected']['border-bottom-width'] | vhnumber"
                  (nzBlur)="updateClassAndWidthHeight()"
                  (ngModelChange)="class['checkbox__selected']['border-bottom-width'] = $event +'px'"></nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="10" [nzStep]="1"
                    [ngModel]="class['checkbox__selected']['border-bottom-width'] | vhnumber"
                    (nzOnAfterChange)="updateClassAndWidthHeight()"
                    (ngModelChange)="class['checkbox__selected']['border-bottom-width'] = $event +'px'"></nz-slider>
                </nz-col>
              </nz-row>
            </div>
            <!-- Lựa chọn màu viền -->
            <div class="item-border">
              <p class="m-0 title">{{'mau_vien' | translate}} </p>
              <div class="color-pick">
                <input id="head" class="input-color" [cpOKButton]="true" [(colorPicker)]="class['checkbox__selected']['border-color']"
                  [style.background]="class['checkbox__selected']['border-color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"  type="button"/>
              </div>
            </div>
            <!-- Nút mở rộng -->
            <div class="item-border my-3" style="float: right;">
              <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">{{'mo_rong' | translate}} &#8594;</p>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <!-- Cấu hình hình dạng viền -->
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll"></div>
</div>